import { ChangeDetectionStrategy, Component, input, InputSignal } from "@angular/core";

export enum TableBadgeStatus {
  SUCCESS = "SUCCESS",
  ERROR = "ERROR",
  WARNING = "WARNING",
  INFO = "INFO",
  EMPTY = "EMPTY",
}

@Component({
  selector: "app-table-status-badge",
  templateUrl: "./table-status-badge.component.html",
  styleUrl: "./table-status-badge.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableStatusBadgeComponent {
  public readonly status: InputSignal<TableBadgeStatus> = input.required<TableBadgeStatus>();
  public readonly label: InputSignal<string> = input.required<string>();
  /** "contract": the Contracts page pill (15% tint fill and border, own colours per theme). */
  public readonly appearance: InputSignal<"default" | "contract"> = input<"default" | "contract">(
    "default",
  );
}
